module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-pala-rosa-024-1200x2490.8a9546ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-pala-rosa-024-1200x2490.jpg
// module id = 1110
// module chunks = 37